<template>
  <div class="page-content">
    <page-template ref="addColumn"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="editColumns"
                   :detailColumns="detailColumns"
    ></page-template>
    <add-form ref="addFormOptions" @submit="upgradePwd"></add-form>
  </div>
</template>
<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import api from "@/config/api";
  import userPower from "@/mixin/userPower";
  import addForm from "@/components/template/add";

  export default {
    mixins: [userPower],
    components: {
      pageTemplate,
      addForm,
    },
    data() {
      return {
        dialogVisibility: false,
        listShow: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              data: [],
              url: api.store.store,
            },
            {
              label: "店长名称",
              prop: "name",
              type: "input",
              ifFuzzy: true,
              placeholder: "请输入店长名称",
            },
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: "添加",
            code: "insert",
          },
          {
            label: "删除",
            code: "delete",
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: "编辑",
            code: "update",
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: "修改密码",
            code: "updatePassword",
            callback: this.updatePassword
          },
          {
            label: "退出",
            code: "logout",
            callback: this.logout
          },
        ],
        // 表格信息配置
        tableOptions: {
          param: {type: 20},
          indexShow: true,//是否显示索引
          columns: [
            {
              label: "工号",
              prop: "loginName",
              width: "120",
              align: "center",
            },
            {
              label: "手机号",
              prop: "phone",
              width: "120",
              align: "center",
            },
            {label: "姓名", prop: "name", width: "120", align: "center"},
            {
              label: "门店名称",
              prop: "storeName",
              width: "150",
              align: "center",
            },
            {
              label: "在线状态",
              prop: "onlineStatus",
              width: "120",
              align: "center",
              enumData: this.$utils.getCacheStatus("sysUser.onlineStatus"),
            },
            {
              label: "创建时间",
              prop: "lastModifyDttm",
              width: "150",
              align: "center",
            },
          ],
          url: api.system.account,
        },
        // 添加字段
        addColumns: {
          labelWidth: "120px",
          span: 12,
          param: {type: 20},
          columns: [
            {
              label: "工号",
              type: "code",
              prop: "loginName",
              isButtonShow: false,
              tipsInfo: '登录账号重复请重新输入！',
              checkUrl: api.system.account + "/check/login/name",
              rule: [
                {required: true, message: "请输入登陆账号", trigger: "blur"},
                {
                  min: 2,
                  max: 15,
                  message: "长度在 2 到 15 个字符",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "手机号",
              type: "code",
              prop: "phone",
              isButtonShow: false,
              tipsInfo: '手机号重复请重新输入！',
              checkUrl: api.system.account + "/verify/phone",
              maxLength: 11,
              rule: [
                {required: true, message: "请输入手机号", trigger: "blur"},
                {pattern: this.$utils.reg.phone, message: "请输入正确的手机号", trigger: 'blur'}
              ],
            },
            {
              label: "登录密码",
              type: "password",
              prop: "passwordPlaintext",
              rule: [{required: true, message: "请输入密码", trigger: "blur"}],
            },
            {
              label: "姓名",
              type: "input",
              prop: "name",
              rule: [{required: true, message: "请输入姓名", trigger: "blur"}],
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              //change: this.getStoreId,
              isHasAll: true,//下拉选择添加‘总部’字段
              url: api.system.seStore,
              rule: [{required: true, message: "请选择门店", trigger: "blur"}],
            },
            // {
            //   label: "选择角色",
            //   prop: "roleId",
            //   type: "radio",
            //   span: 24,
            //   defaultValue: 10001,
            //   disabled: true,
            //   data: [],
            //   url: api.system.role,
            // },
            {
              label: "",
              prop: "type",
              type: "input",
              defaultValue: 20,
              hidden: true,
            },
            {
              label: "选择收银权限",
              prop: "cashierJurisdictionsList",
              type: "checkList",
              span: 24,
              checked: false,
              data: [],
            },
            {
              label: "选择管店权限",
              prop: "storeJurisdictionsList",
              type: "checkList",
              span: 24,
              checked: false,
              data: [],
            },
          ],
          url: api.system.account,
        },
        editColumns: {
          labelWidth: "120px",
          span: 12,
          param: {type: 20},
          columns: [
            {
              label: "登陆账号",
              type: "input",
              prop: "loginName",
              disabled: true,
            },
            {
              label: "手机号",
              type: "input",
              prop: "phone",
              maxLength: 11,
              rule: [
                {required: true, message: "请输入手机号", trigger: "blur"},
                {pattern: this.$utils.reg.phone, message: "请输入正确的手机号", trigger: 'blur'}
              ],
            },
            {
              label: "姓名",
              type: "input",
              prop: "name",
              rule: [{required: true, message: "请输入姓名", trigger: "blur"}],
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              data: [],
              url: api.store.store,
              disabled: true
            },
            // {
            //   label: "选择角色",
            //   prop: "roleId",
            //   type: "radio",
            //   span: 24,
            //   defaultValue: 10001,
            //   disabled: true,
            //   data: [],
            //   url: api.system.role,
            // },
            {
              label: "",
              prop: "type",
              type: "input",
              defaultValue: 20,
              hidden: true,
            },
            {
              label: "选择收银权限",
              prop: "cashierJurisdictionsList",
              type: "checkList",
              span: 24,
              checked: false,
              data: [],
            },
            {
              label: "选择管店权限",
              prop: "storeJurisdictionsList",
              type: "checkList",
              span: 24,
              checked: false,
              data: [],
            },
          ],
          url: api.system.account,
        },
        detailColumns: {
          span: 8,
          labelWidth: "130",
          columns: [
            {label: "ID", prop: "id"},
            {
              label: "登陆账号",
              prop: "loginName",
            },
            {label: "手机号", prop: "phone"},
            {label: "姓名", prop: "name"},
            {
              label: "门店名称",
              prop: "storeName",
            },
            {
              label: "状态",
              prop: "status",
              enumData: this.$utils.getCacheStatus("sysUser.status"),
            },
            {
              label: "收银权限",
              prop: "cashierJurisdictionsList",
              deal: this.showCashierCheckList,
            },
            {
              label: "管店权限",
              prop: "storeJurisdictionsList",
              deal: this.showStoreCheckList,
            },
            {
              label: "创建时间",
              prop: "createDttm",
            },
          ],
          url: api.system.account,
        },
        storeJurisdictionsList: [],
        cashierJurisdictionsList: [],
        //修改密码
        changePwdDialog: {
          formType: "other",
          labelWidth: "100px",
          span: 12,
          columns: [
            {
              label: "员工姓名",
              type: "input",
              prop: "name",
              disabled: true
            },
            {
              label: "登录用户名",
              type: "input",
              prop: "loginName",
              disabled: true
            },
            {
              label: "新密码",
              type: "password",
              prop: "newPasswordPlaintext",
              rule: [
                {required: true, message: "请输入密码", trigger: "blur"},
                {
                  min: 6,
                  max: 20,
                  message: "长度在6到 20个字符",
                  trigger: "blur"
                }
              ]
            },
            {
              label: "确认密码",
              type: "repassword",
              prop: "rePassword",
              passwordProp: "newPasswordPlaintext",
            }
          ],
          url: api.system.account,
          formData: {},
        },
      };
    },
    created() {
      this.getSysJurisdiction(20, "storeJurisdictionsList");
      this.getSysJurisdiction(40, "cashierJurisdictionsList");
      this.setStore(this.searchOptions.simple);
      this.getShopPower(this.addColumns.columns);
    },
    methods: {
      // 退出
      logout(row) {
        if (row.sessionId) {
          this.$confirm('退出用户' + row.name + '？确认')
            .then(_ => {
              this.$axios.fetchPost(api.system.logout, {sessionId: row.sessionId}).then(res => {
                this.$refs['addColumn'].getData()
              })
            })
            .catch(_ => {
            });
        } else {
          this.$message({
            type: 'warning',
            message: '该用户已离线或不存在'
          })
        }
      },
      showCashierCheckList(data) {
        if (!data || data.length == 0) return "";
        let rtn = "";
        this.cashierJurisdictionsList.map((item) => {
          if (
            data.filter((d) => {
              return item.id == d.id;
            }).length > 0
          ) {
            rtn += item.name + ",";
          }
        });
        return rtn;
      },
      showStoreCheckList(data) {
        if (!data || data.length == 0) return "";
        let rtn = "";
        this.storeJurisdictionsList.map((item) => {
          if (
            data.filter((d) => {
              return item.id == d.id;
            }).length > 0
          ) {
            rtn += item.name + ",";
          }
        });
        return rtn;
      },
      getSysJurisdiction(type, columnProp) {
        this.$axios
          .fetchPost(api.system.sysJurisdiction, {type})
          .then((data) => {
            if (data.code == 200 && data.data) {
              if (type == 20)
                this.storeJurisdictionsList = this.$utils.deepClone(data.data);
              else
                this.cashierJurisdictionsList = this.$utils.deepClone(data.data);
              data.data.map((item) => {
                item.checked = false;
              });
              this.addColumns.columns.filter((item) => {
                return item.prop == columnProp;
              })[0].data = data.data;
              this.editColumns.columns.filter((item) => {
                return item.prop == columnProp;
              })[0].data = data.data;
            }
          });
      },
      getStoreId(data) {
        this.$axios.fetchPost(api.system.account + '/list', {retaleId: data.storeId, type: 20}).then(data => {
          if (data.code === 200) {
            if (data.data.length > 0) {
              this.$refs.addColumn.$refs.formTemplate.formModel.storeId = '';
              this.$message({message: "该门店已添加店长，请勿重复添加！", type: "warning"});
            }
          }
        });
      },
      updatePassword(row) {
        this.changePwdDialog.formData = row;
        this.$nextTick(() => {
          this.addColumns && this.$store.commit(this.$utils.storeKeys.OTHERFORM, this.changePwdDialog);
          this.$refs['addFormOptions'].setFormOptions('other', row.id, '修改密码');
        })
      },
      upgradePwd(data) {
        let params = {id: data.id, newPassword: data.newPassword};
        this.$axios.fetchPost(api.system.account + "/password" + `?${this.$utils.JSONToString(params)}`, {}).then(result => {
          if (result.code === 200) {
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({type: 'success', message: '修改成功!'});
          } else {
            this.$message({type: 'error', message: result.msg});
          }
        }).catch(err => {
          this.$notify({
            type: "error",
            title: '修改操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type: 'error', message: '修改失败!'});
        })
      }
    },
  };
</script>




// WEBPACK FOOTER //
// src/page/system/user/Shopkeeper.vue